module.exports = __webpack_public_path__ + "static/media/choithramsKetogenic.ad38ecd1.png";